import { http } from '../../../../api/http';
import type { DireccionTrabajador } from '../types/direccion.types';

const BASE = '/planilla/trabajador/direccion';

export class DireccionService {
  static async getByTrabajador(idTrabajador: number): Promise<DireccionTrabajador[]> {
    const { data } = await http.get(`${BASE}/${idTrabajador}`);
    return data;
  }

  static async getById(id: number): Promise<DireccionTrabajador> {
    const { data } = await http.get(`${BASE}/detalle/${id}`);
    return data;
  }

  static async save(direccion: DireccionTrabajador): Promise<DireccionTrabajador> {
    const { data } = await http.post(BASE, direccion);
    return data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  }
}
